import { useMemo } from 'react';
import { graphql } from 'react-relay';
import { useQueryInterop } from '@confluence/apollo-relay-interop/entry-points/useQueryInterop.ts';

import type {
	useLicensedProductsQueryForGlobalAppShortcutsQuery$data,
	useLicensedProductsQueryForGlobalAppShortcutsQuery$variables,
} from './__generated__/useLicensedProductsQueryForGlobalAppShortcutsQuery.graphql.ts';

const useLicensedProductsQueryForGlobalAppShortcuts = graphql`
	query useLicensedProductsQueryForGlobalAppShortcutsQuery {
		confluence_tenantContext {
			licensedProducts {
				licenseStatus
				productKey
			}
		}
	}
`;

export const useLicensedProducts = () => {
	const { data } = useQueryInterop<
		useLicensedProductsQueryForGlobalAppShortcutsQuery$data,
		useLicensedProductsQueryForGlobalAppShortcutsQuery$variables
	>(useLicensedProductsQueryForGlobalAppShortcuts);

	return useMemo(() => {
		const licensedProducts = data?.confluence_tenantContext?.licensedProducts || [];
		return licensedProducts.reduce(
			(acc, product) => {
				if (product.licenseStatus !== 'ACTIVE') {
					return acc;
				}

				switch (product.productKey) {
					case 'jira-software':
						acc.hasJira = true;
						break;
					case 'loom':
						acc.hasLoom = true;
						break;
					default:
						break;
				}
				return acc;
			},
			{ hasJira: false, hasLoom: false },
		);
	}, [data]);
};
